export const environment = {
  production: false,
  systemUrl: '/core/',
  //systemUrl: 'https://localhost:5001/',
  get apiUrl(): string {
    return this.systemUrl + 'api'
  },
  get signalRUrl(): string {
    return this.systemUrl + 'signalr'
  },
  get examSignalRUrl(): string {
    return this.systemUrl + 'examSignalR'
  },
  get chatSignalRUrl(): string {
    return this.systemUrl + 'chatSignalR'
  },
  get notificationSignalRUrl(): string {
    return this.systemUrl + 'notificationSignalR';
  },
  get importSignalRUrl(): string {
    return this.systemUrl + 'importSignalR'
  },
  get propagateSignalRUrl(): string {
    return this.systemUrl + 'propagateSignalR'
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
